import { useState } from 'react';
import CustomerMonitoringQueuePage from './_components/CustomerMonitoringQueuePage';
import CustomerMonitoringListPage from './_components/CustomerMonitoringListPage';
import { Queue, FormatListBulleted } from '@mui/icons-material';
import { CustomerRecognitionEventViewType } from '../../services/Events/CustomerRecognitionEventService/types';
import { Grid2 } from '@mui/material';
import HeaderDashboard from 'pages/DashboardPageClient/_components/_ui/Header';

const CustomerMonitoringPage = () => {
  const [view, setView] = useState<CustomerRecognitionEventViewType>(
    CustomerRecognitionEventViewType.LIST,
  );

  // const items: ISwitchViewComponentItems[] = [
  //   {
  //     tooltip: 'Lista',
  //     icon: <FormatListBulleted sx={{ color: '#ffffff' }} />,
  //     value: CustomerRecognitionEventViewType.LIST,
  //   },
  //   {
  //     tooltip: 'Fila',
  //     icon: <Queue sx={{ color: '#ffffff' }} />,
  //     value: CustomerRecognitionEventViewType.QUEUE,
  //   },
  // ];

  const renderView = () => {
    switch (view) {
      case 0:
        return <CustomerMonitoringQueuePage />;
      case 1:
        return <CustomerMonitoringListPage />;
      default:
        throw new Error('Not implemented.');
    }
  };

  return (
    <Grid2 size={12}>
      <HeaderDashboard></HeaderDashboard>
      <Grid2
        display="flex"
        flexDirection={{ xs: 'column-reverse', md: 'row' }}
        justifyContent={{ xs: 'center', md: 'start' }}
        alignItems={{ xs: 'center', md: 'start' }}
      >
        {renderView()}
      </Grid2>
    </Grid2>
  );
};

export default CustomerMonitoringPage;
